var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { UIService } from "../ui/UIService.js";
import { flags } from "../console/flags.js";
import "../global-33d5eebf.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "lodash";
import "../console/editor.js";
import "../components/ComponentRegistry.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../enums-86f58524.js";
import "../components/types.js";
import "../utils/byteArray.js";
import "../console/floatingwindow.js";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
class GameInstance {
  constructor(options) {
    __publicField(this, "gameModel");
    __publicField(this, "achievementService");
    __publicField(this, "uiService");
    __publicField(this, "lastTime", 0);
    __publicField(this, "dt", 16);
    __publicField(this, "render30Fps");
    this.options = options;
    if (options.uiService) {
      this.uiService = options.uiService === true ? UIService.getInstance() : options.uiService;
    }
    this.achievementService = options.achievementService ?? {
      registerAchievement: () => {
      },
      flush: async () => {
      },
      update: async () => {
      },
      getAchievements: () => [],
      unlockAchievement: () => {
      },
      getUnlockedAchievements: () => [],
      getAchievement: () => null,
      getAchievementProgress: () => 0,
      setAchievementProgress: () => false,
      incrementAchievementProgress: () => false,
      resetAchievementProgress: () => {
      }
    };
  }
  async initialize(roomId, seed, { players, coreOverrides } = {}) {
    if (!this.options.connection.localPlayers.every(({ connected }) => connected) && !this.options.connection.solohost) {
      throw new Error("Player not connected");
    }
    if (this.options.connection.localPlayers[0].currentRoomId) {
      this.options.connection.leaveRoom();
    }
    if (this.gameModel && !this.gameModel.destroyed) {
      this.gameModel.destroy();
    }
    if (this.options.connection.hasRoom(roomId)) {
      this.join(roomId, seed);
    } else {
      const gameModel = await this.options.connection.initialize(roomId, {
        gameInstance: this,
        players: players ?? this.options.connection.players.map((p) => p.netId),
        seed: seed ?? "NO_SEED",
        coreOverrides,
        buildWorld: this.options.buildWorld,
        onPlayerJoin: this.options.onPlayerJoin,
        onPlayerLeave: this.options.onPlayerLeave
      });
      this.gameModel = gameModel;
    }
  }
  async host(roomId, seed, playerConfig, coreOverrides) {
    if (!this.options.connection.localPlayers.every(({ connected }) => connected) && !this.options.connection.solohost) {
      throw new Error("Player not connected");
    }
    if (this.options.connection.localPlayers[0].currentRoomId) {
      this.options.connection.leaveRoom();
    }
    if (this.gameModel && !this.gameModel.destroyed) {
      this.gameModel.destroy();
    }
    const gameModel = await this.options.connection.host(roomId, {
      gameInstance: this,
      seed: seed ?? "NO_SEED",
      coreOverrides,
      buildWorld: this.options.buildWorld,
      onPlayerJoin: this.options.onPlayerJoin,
      onPlayerLeave: this.options.onPlayerLeave,
      playerConfig
    });
    this.gameModel = gameModel;
  }
  async join(roomId, seed, playerConfig, coreOverrides) {
    if (!this.options.connection.player.connected) {
      throw new Error("Player not connected");
    }
    if (this.options.connection.player.currentRoomId) {
      this.options.connection.leaveRoom();
    }
    if (this.gameModel && !this.gameModel.destroyed) {
      this.gameModel.destroy();
    }
    const gameModel = await this.options.connection.join(roomId, {
      gameInstance: this,
      seed: seed ?? "NO_SEED",
      coreOverrides,
      onPlayerLeave: this.options.onPlayerLeave,
      playerConfig
    });
    this.gameModel = gameModel;
  }
  run() {
    if (this.options.connection.localPlayers[0].currentRoomId) {
      this.runGameLoop();
      if (this.gameModel.destroyed) {
        this.options.connection.leaveRoom();
      }
    }
  }
  runGameLoop() {
    if (!this.gameModel) {
      return;
    }
    try {
      if (this.options.connection.frameSkipCheck(this.gameModel)) {
        return;
      }
      this.options.connection.handleInput(this.gameModel);
      const dt = this.dt;
      this.gameModel.frameDt = dt;
      this.lastTime = performance.now();
      this.gameModel.run();
      if (this.gameModel.destroyed) {
        console.log("destroyed");
        return;
      }
      if (!flags.FPS_30 || this.gameModel.frame % 2 === 0) {
        this.gameModel.runPredraw();
        this.gameModel.runPixiComponents();
        this.gameModel.runUIComponents();
      }
      this.gameModel.frame++;
      this.gameModel.timeElapsed += dt;
      this.gameModel.cleanup();
      this.options.connection.run(this.gameModel);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }
}
export {
  GameInstance
};
//# sourceMappingURL=GameInstance.js.map
